const AUTH_STORAGE_KEYS = ['authToken', 'username'];
const LEGACY_PASSWORD_GUARD_STORAGE_KEY = 'isAuthenticated';
const FRONTEND_BUILD_STORAGE_KEY = 'frontendBuildId';

export const FRONTEND_BUILD_ID = process.env.VUE_APP_BUILD_ID || 'development';

function getStorage(name) {
    if (typeof window === 'undefined') {
        return null;
    }

    try {
        return window[name];
    } catch {
        return null;
    }
}

function getStorageItem(storage, key) {
    try {
        return storage?.getItem(key) || null;
    } catch {
        return null;
    }
}

function setStorageItem(storage, key, value) {
    try {
        storage?.setItem(key, value);
    } catch {
        // Ignore browsers that block storage; the app can still run as a guest.
    }
}

function removeStorageItem(storage, key) {
    try {
        storage?.removeItem(key);
    } catch {
        // Ignore browsers that block storage; the app can still run as a guest.
    }
}

export function clearFrontendAuthSession() {
    const local = getStorage('localStorage');
    const session = getStorage('sessionStorage');

    AUTH_STORAGE_KEYS.forEach(key => {
        removeStorageItem(local, key);
        removeStorageItem(session, key);
    });
    // Remove the flag left by the retired client-side password guard.
    removeStorageItem(local, LEGACY_PASSWORD_GUARD_STORAGE_KEY);
}

export function getStoredFrontendBuildId() {
    return getStorageItem(getStorage('localStorage'), FRONTEND_BUILD_STORAGE_KEY);
}

export function setStoredFrontendBuildId(buildId) {
    if (!buildId) {
        return;
    }

    setStorageItem(getStorage('localStorage'), FRONTEND_BUILD_STORAGE_KEY, buildId);
}

export function getCurrentLoginUrl() {
    if (typeof window === 'undefined') {
        return '/login';
    }

    const { pathname, search, hash } = window.location;
    const localeMatch = pathname.match(/^\/(nl|en|id)(?:\/|$)/);
    const localePrefix = localeMatch ? `/${localeMatch[1]}` : '';
    const loginPath = `${localePrefix}/login`;
    const currentPath = `${pathname}${search}${hash}`;

    if (pathname === loginPath) {
        return loginPath;
    }

    const params = new URLSearchParams({ redirect: currentPath });
    return `${loginPath}?${params.toString()}`;
}
